/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Planning_Stop_HelpInputs */



/**
* | output |
* | --- |
* | "Summer: ventilation stopped Winter: ventilation in frost-free mode" |
*
* @param {Air_Handler_Unit_Planning_Stop_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_planning_stop_help = /** @type {((inputs?: Air_Handler_Unit_Planning_Stop_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Planning_Stop_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer: ventilation stopped\nWinter: ventilation in frost-free mode")
	return /** @type {LocalizedString} */ ("Été : ventilation à l'arrêt\nHiver : ventilation en Hors Gel")
});